import React from 'react'
import { TopNav as SAPUITopNav } from '@tencent/spaui'
import useUserInfo from './useUserInfo'
import { PopOver, OverlayTrigger } from '@tencent/spaui-popover'

const TopNavDrop = () => {
    const { userInfo = {}, signOut } = useUserInfo()
    return (
        <li className="nav-item spaui-topnav-drop">
            <a className="nav-link" href="#">
                <div className="icon-avator">
                    <img src={userInfo.face || 'https://ui.qzone.com/80x80'} alt="" />
                </div>
                {userInfo.name}
                <i className="icon-darr"></i>
            </a>
            <div className={`spaui-topnav-menu my-card ${userInfo.openId ? 'my-card-large' : ''}`}>
                <div className="feed-item">
                    <div className="feed-img">
                        <img src={userInfo.face || 'https://ui.qzone.com/80x80'} alt="" />
                    </div>
                    <div className="feed-info">
                        <div className="feed-title">{userInfo.name}</div>
                        {userInfo.openId ? (
                            <React.Fragment>
                                <div className="feed-desc">
                                    <span className="feed-desc-item">
                                        授权唯一标识
                                        <OverlayTrigger
                                            overlay={
                                                <PopOver>
                                                    应用宝授权标识（myapp_auth_key）是通过 Marketing API
                                                    管理渠道包时必填的参数， 是每个应用宝open账号下分配的唯一授权标识。
                                                </PopOver>
                                            }
                                        >
                                            <i className="icon icon-help"></i>
                                        </OverlayTrigger>
                                        :
                                    </span>
                                </div>
                                <div className="feed-desc">
                                    <span className="feed-desc-item">{userInfo.openId}</span>
                                </div>
                            </React.Fragment>
                        ) : null}
                    </div>
                </div>
                <div className="my-card-footer">
                    <button
                        className="spaui-button spaui-button-default spaui-component"
                        type="button"
                        onClick={signOut}
                    >
                        退出
                    </button>
                </div>
            </div>
        </li>
    )
}

const topNavCofig = {
    title: '广告投放-渠道包管理',
    rootUrl: '/static',
    list: [
        {
            placement: 'right',
            value: '11',
            data: [
                {
                    type: 'component',
                    component: TopNavDrop,
                },
            ],
        },
    ],
}

const TopNav = props => {
    return (
        <SAPUITopNav
            {...topNavCofig}
            style={{
                position: 'relative',
            }}
        />
    )
}

export default TopNav
